import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { ITraderGroupPromiseLookupService } from "../ITraderGroupPromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class TraderGroupPromiseLookupService
  extends PromiseLookupService<string, CubiqTS.TradingGroupImpl>
  implements ITraderGroupPromiseLookupService
{
  constructor() {
    super();
  }

  abstract getTraderGroup(id: CubiqTS.Long): Promise<CubiqTS.TradingGroupImpl>;
  abstract getTraderGroupForSid(id: string): Promise<CubiqTS.TradingGroupImpl>;
}
